import { Label, Message, Select, Spinner } from '@sbab-ui/components'
import { ListInterest } from '../api/httpHandlers'
import LoanLengthOptions from './LoanLengthOptions'
import MortgageOptions from './MortgageOptions'
import { ChangeEvent } from 'react'

interface Props {
  value: number
  label: string
  cirkatid?: boolean
  id: 'mortgageRateIndex' | 'personalLoanLengthInYears'
  selectChangeHandler: (event: ChangeEvent<HTMLSelectElement>) => void
  errorMessage?: string
  isValidHandler?: (value: number) => boolean
  options?: ListInterest[]
  interestDeviation?: number
  userIsChangingMortgageValues?: boolean
}

function CustomSelect({
  value,
  label,
  cirkatid,
  id,
  selectChangeHandler,
  errorMessage,
  isValidHandler,
  options,
  interestDeviation = 0,
  userIsChangingMortgageValues = false
}: Readonly<Props>) {
  let hasError = false
  if (isValidHandler !== undefined) {
    hasError = !isValidHandler(value)
  }
  return (
    <div className="mb-2 flex w-full flex-col lg:mr-3 lg:max-w-[47%]">
      <Label className="mb-1" htmlFor={id}>
        {label}
      </Label>
      <div
        style={{
          alignSelf: 'flex-start',
          fontWeight: 500
        }}
      >
        {cirkatid}
      </div>

      {userIsChangingMortgageValues ? (
        <div className="relative">
          <div className="absolute left-0 right-0 z-10 mx-auto flex w-full  justify-center sm:max-w-[13.6rem]">
            <Spinner />
          </div>
        </div>
      ) : null}
      <Select
        data-cs-mask
        id={id}
        value={value.toString()}
        data-label={id}
        onChange={selectChangeHandler}
        invalid={hasError}
        disabled={userIsChangingMortgageValues}
      >
        {id === 'mortgageRateIndex' ? (
          <MortgageOptions
            options={options as ListInterest[]}
            interestDeviation={interestDeviation}
          />
        ) : (
          <LoanLengthOptions />
        )}
      </Select>
      {cirkatid ? (
        <Message className="mt-2 !text-neutral-800">*Cirkatider på 2 - 10 års bindningstid.</Message>
      ) : null}
      {hasError ? (
        <Message tone="critical" className="mt-1">
          {errorMessage}
        </Message>
      ) : null}
    </div>
  )
}

export default CustomSelect
